import { Capacitor } from '@capacitor/core'
import { i18n } from '@lingui/core'
import { EmailComposer } from 'capacitor-email-composer'

import { globalDefinitions } from '@/defined-translations'
import { openUrl } from '@/utils/external-resources'

type OpenMailOptions = {
  to: string[]
  subject?: string
  body?: string
  onError?: (message: string) => void
}

export const openMail = async ({ to, subject, body, onError }: OpenMailOptions) => {
  if (Capacitor.isNativePlatform()) {
    const { hasAccount } = await EmailComposer.hasAccount()
    if (!hasAccount) {
      onError?.(i18n._(globalDefinitions.task.FileUploadRequest.no_email_account))

      return
    }
    await EmailComposer.open({ to, subject, body })

    return
  }

  void openUrl(buildMailtoUrl({ to, subject, body }), { target: '_self' })
}

const buildMailtoUrl = ({ to, subject, body }: OpenMailOptions) => {
  const parameters: string[] = []
  if (subject) parameters.push(`subject=${encodeURIComponent(subject)}`)
  if (body) parameters.push(`body=${encodeURIComponent(body)}`)

  const query = parameters.join('&')
  return `mailto:${to.join(',')}${query ? `?${query}` : ''}`
}
